/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";

/**
 * Shared payload shape for the unproxied MCP server tool/user/client usage breakdowns
 */
export type UnproxiedMcpServerUsageBreakdownPayload = {
  /**
   * Cursor for pagination
   */
  cursor?: string | undefined;
  /**
   * Start time in ISO 8601 format
   */
  from: Date;
  /**
   * Number of items to return (1-500)
   */
  limit?: number | undefined;
  /**
   * End time in ISO 8601 format
   */
  to: Date;
  /**
   * The unproxied MCP server's vendor URL
   */
  url: string;
};

/** @internal */
export type UnproxiedMcpServerUsageBreakdownPayload$Outbound = {
  cursor?: string | undefined;
  from: string;
  limit: number;
  to: string;
  url: string;
};

/** @internal */
export const UnproxiedMcpServerUsageBreakdownPayload$outboundSchema:
  z.ZodMiniType<
    UnproxiedMcpServerUsageBreakdownPayload$Outbound,
    UnproxiedMcpServerUsageBreakdownPayload
  > = z.object({
    cursor: z.optional(z.string()),
    from: z.pipe(z.date(), z.transform(v => v.toISOString())),
    limit: z._default(z.int(), 50),
    to: z.pipe(z.date(), z.transform(v => v.toISOString())),
    url: z.string(),
  });

export function unproxiedMcpServerUsageBreakdownPayloadToJSON(
  unproxiedMcpServerUsageBreakdownPayload:
    UnproxiedMcpServerUsageBreakdownPayload,
): string {
  return JSON.stringify(
    UnproxiedMcpServerUsageBreakdownPayload$outboundSchema.parse(
      unproxiedMcpServerUsageBreakdownPayload,
    ),
  );
}
